const NotFound = () => import('@/views/ErrorPages/index.vue');

const routes = [
  {
    path: '/401',
    component: NotFound,
    name: 'Page401',
    hidden: true,
    meta: { title: 'Unauthorized' },
    props: {
      title: 'Unauthorized',
      description: "You don't have access to this page. <br> Maybe you need to change role?",
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'Page404',
    hidden: true,
    meta: { title: 'Page 404' },
  },
];

export default routes;
